import React, { useEffect, useState } from 'react';
import { useVgpsSessionState } from 'livekit_web/react';
import type { VgpsPlaybackSession } from 'livekit_web';

export interface PlaybackSelection {
  startTsMs: number;
  endTsMs: number;
}

export interface PlaybackControlsProps {
  session: VgpsPlaybackSession | null;
  selection: PlaybackSelection;
  playbackRate: number;
  onPlaybackRateChange: (rate: number) => void;
}

const RATE_OPTIONS = [0.5, 1, 1.5, 2];

export function PlaybackControls({
  session,
  selection,
  playbackRate,
  onPlaybackRateChange,
}: PlaybackControlsProps): JSX.Element {
  const state = useVgpsSessionState(session);
  const [seekTsMs, setSeekTsMs] = useState(selection.startTsMs);

  useEffect(() => {
    setSeekTsMs(selection.startTsMs);
  }, [selection.startTsMs]);

  const run = async (cb: (s: VgpsPlaybackSession) => Promise<void>): Promise<void> => {
    if (session) await cb(session);
  };

  return (
    <div
      style={{
        display: 'grid',
        gap: 12,
        marginTop: 16,
        padding: 16,
        borderRadius: 12,
        backgroundColor: '#ffffff',
        border: '1px solid #e6ecf2',
      }}
    >
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
        <button type="button" onClick={() => void run((s) => s.play())}>
          Play
        </button>
        <button type="button" onClick={() => void run((s) => s.pause())}>
          Pause
        </button>
        <button
          type="button"
          onClick={() => void run((s) => s.seek(selection.startTsMs))}
        >
          Jump To Start
        </button>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          Rate
          <select
            value={playbackRate}
            onChange={async (e) => {
              const next = Number(e.target.value);
              onPlaybackRateChange(next);
              if (session) await session.setPlaybackRate(next);
            }}
          >
            {RATE_OPTIONS.map((r) => (
              <option key={r} value={r}>
                {r}x
              </option>
            ))}
          </select>
        </label>
      </div>

      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          Seek (epoch ms)
          <input
            type="number"
            value={seekTsMs}
            onChange={(e) => setSeekTsMs(Number(e.target.value))}
            style={{ minWidth: 260 }}
          />
        </label>
        <button type="button" onClick={() => void run((s) => s.seek(seekTsMs))}>
          Seek
        </button>
      </div>

      <div style={{ color: '#4f6378', fontSize: 13 }}>
        Session state: <strong>{state}</strong>
      </div>
    </div>
  );
}
